module.exports = __webpack_public_path__ + "img/header.d49b50b.jpg";